import React, { useState } from 'react';

/**
 * Public "Managed by Karbon360" badge page — clients download the mark for
 * their website and materials. No auth required.
 */
const BadgePage = () => {
  const [copied, setCopied] = useState(false);

  const embedSnippet = `<a href="https://app.karbon360.tech" target="_blank" rel="noopener">
  <img src="https://app.karbon360.tech/badges/karbon360-badge-light.png"
       alt="Managed by Karbon360" height="48" />
</a>`;

  const handleCopy = () => {
    navigator.clipboard.writeText(embedSnippet).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const card = {
    background: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: 16,
    padding: 28
  };

  const btn = {
    display: 'inline-block',
    padding: '10px 18px',
    borderRadius: 8,
    background: '#0e1a2b',
    color: '#3fffd8',
    fontSize: 13,
    fontWeight: 600,
    textDecoration: 'none',
    border: 'none',
    cursor: 'pointer'
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <header style={{ background: '#0e1a2b', padding: '28px 24px' }}>
        <div style={{ maxWidth: 860, margin: '0 auto' }}>
          <div style={{ color: '#3fffd8', fontSize: 12, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase' }}>Karbon360°</div>
          <h1 style={{ color: '#eaf2f0', fontSize: 28, fontWeight: 800, margin: '8px 0 4px' }}>"Managed by Karbon360" Badge</h1>
          <p style={{ color: '#8fa3a0', fontSize: 14, margin: 0, maxWidth: 560 }}>
            Organizations whose greenhouse-gas inventory is compiled with Karbon360 may display this
            mark on their website, reports and materials.
          </p>
        </div>
      </header>

      <main style={{ maxWidth: 860, margin: '0 auto', padding: '32px 24px', display: 'grid', gap: 20 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 20 }}>
          <div style={card}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#111827', marginBottom: 4 }}>Light backgrounds</div>
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 16 }}>For white or light pages.</div>
            <div style={{ background: '#f3f4f6', borderRadius: 12, padding: '28px 16px', textAlign: 'center', marginBottom: 16 }}>
              <img src="/badges/karbon360-badge-light.png" alt="Managed by Karbon360 — light" style={{ height: 56, maxWidth: '100%' }} />
            </div>
            <a href="/badges/karbon360-badge-light.png" download="karbon360-badge-light.png" style={btn}>Download PNG</a>
          </div>

          <div style={card}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#111827', marginBottom: 4 }}>Dark backgrounds</div>
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 16 }}>For dark or navy pages.</div>
            <div style={{ background: '#0e1a2b', borderRadius: 12, padding: '28px 16px', textAlign: 'center', marginBottom: 16 }}>
              <img src="/badges/karbon360-badge-dark.png" alt="Managed by Karbon360 — dark" style={{ height: 56, maxWidth: '100%' }} />
            </div>
            <a href="/badges/karbon360-badge-dark.png" download="karbon360-badge-dark.png" style={btn}>Download PNG</a>
          </div>
        </div>

        <div style={card}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#111827', marginBottom: 12 }}>Embed on your website</div>
          <pre style={{
            background: '#0e1a2b',
            color: '#c9d4d1',
            borderRadius: 10,
            padding: 16,
            fontSize: 12,
            lineHeight: 1.6,
            overflowX: 'auto',
            margin: '0 0 12px'
          }}>{embedSnippet}</pre>
          <button style={btn} onClick={handleCopy}>{copied ? 'U kopjua ✓' : 'Copy code'}</button>
        </div>

        <div style={{ ...card, fontSize: 12.5, color: '#6b7280', lineHeight: 1.7 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#111827', marginBottom: 8 }}>Usage</div>
          The badge states that the organization's GHG inventory is <b>managed with Karbon360</b> — it is
          not an environmental-performance claim or a certification of carbon neutrality. Do not alter the
          colors, proportions or wording of the mark. Minimum display height: 32&nbsp;px.
        </div>
      </main>

      <footer style={{ maxWidth: 860, margin: '0 auto', padding: '0 24px 32px', fontSize: 12, color: '#9ca3af' }}>
        Karbon360° · karbon360.tech
      </footer>
    </div>
  );
};

export default BadgePage;
